import { render, staticRenderFns } from "./SeniorRetouchersMainPhotoBlock.vue?vue&type=template&id=e063c53e&"
import script from "./SeniorRetouchersMainPhotoBlock.vue?vue&type=script&lang=js&"
export * from "./SeniorRetouchersMainPhotoBlock.vue?vue&type=script&lang=js&"
import style0 from "./SeniorRetouchersMainPhotoBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports